const priceBox = document.getElementById("rb-price");

async function calculate() {
  const metal = document.getElementById("rb-metal").value;

  const res = await fetch(
    "https://danhov.innovatedevelopers.com/gold-price"
  );
  const gold = await res.json();

  const rate =
    metal == 18 ? gold.per_gram_18k : gold.per_gram_22k;

  const price =
    rate * RB_DATA.weight + RB_DATA.making;

  priceBox.innerText = price.toFixed(0);
}

document.getElementById("rb-next").onclick = () => {
  const price = document.getElementById("rb-price").innerText;

  if (price === "—") {
    alert("Please select ring options first");
    return;
  }

  localStorage.setItem("ring_price", Number(price));
  window.location.href = "/pages/select-diamond";
};

